import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

/* MODAL */
import { useModal } from 'hooks/modalContext';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

const Dispatch = () => {
  const { openModal } = useModal();

  const [workerMstList, setWorkerMstList] = useState([{
    workerId: '',
    serialNumber: '',
    workerName: '',
    workerPhone: '',
  }]);
  const [search, setSearch] = useState({ workerId: '' });

  useEffect(() => {
    Common.isLogin();

    getWorkerMstList();
  }, [])

  const getWorkerMstList = () => {
    Server.sendGet('workforce/worker', search, getWorkerMstListCallback).then();
  };

  const getWorkerMstListCallback = res => {
    res?.['resultList'].forEach(v => {
      v.phone = v.workerPhone;
    });

    setWorkerMstList(res?.['resultList']);
  };

  const handleAdd = () => {
    openModal({
      modalName: 'WorkforceDispatchModal',
      modalData: {
        isRegi: true,
        data: {
          item: {},
          callback: getWorkerMstList,
        },
      }
    });
  };

  const handleContent = item => {
    openModal({
      modalName: 'WorkforceDispatchModal',
      modalData: {
        isRegi: false,
        data: {
          item: item,
          callback: getWorkerMstList,
        },
      }
    });
  };

  const onEnter = event => {
    if (event.keyCode === 13) {
      event.preventDefault();

      getWorkerMstList();
    }
  };

  return (
    <>
      <Inner>
        <Title>
          <TitHead>
            <i/>
            <h4>Dispatch workforce management</h4>
          </TitHead>
          <BtnDesc>
            <TitBtn onClick={handleAdd}>
              <Ic src='https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/add_ic.svg'/>
              <span>Dispatch workforce Registration</span>
            </TitBtn>
          </BtnDesc>
        </Title>
        <SearchArea>
          <CateIn>
            <Cate>
              <CateInput
                placeholder='ID, Name, Phone'
                type={'text'}
                id={'workerId'}
                value={search?.workerId}
                onChange={e => {
                  setSearch(() => {
                    return {
                      ...search,
                      workerId: e.target.value,
                    }
                  });
                }}
                onKeyDown={(event) => {
                  onEnter(event);
                }}
              />
            </Cate>
          </CateIn>
          <SearchBtn onClick={getWorkerMstList}>Search</SearchBtn>
        </SearchArea>
        <Content>
          <Table>
            <colgroup>
              <col width='10%'/>
              <col width='25%'/>
              <col width='25%'/>
              <col width='30%'/>
              <col width='10%'/>
            </colgroup>
            <thead>
            <tr>
              <th>No</th>
              <th>ID</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Detail</th>
            </tr>
            </thead>
            <tbody>
            {workerMstList?.map((item, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{item.workerId}</td>
                <td>{item.workerName}</td>
                <td>{item.workerPhone}</td>
                <td>
                  <TitBtn onClick={() => handleContent(item)}>
                    <span>Detail</span>
                  </TitBtn>
                </td>
              </tr>
            ))}
            {Common.isEmpty(workerMstList) &&
              <tr>
                <td colSpan={5} className={'none-data'}>
                  There is no data to output.
                </td>
              </tr>
            }
            </tbody>
          </Table>
        </Content>
      </Inner>
    </>
  );
}

const Inner = styled.div`
  flex: 1;
  background: #ffffff;
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }
`;

const BtnDesc = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;
`;

const TitBtn = styled.button`
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  gap: 0 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  border-radius: 5px;
  margin: auto;

  & span {
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

const SearchArea = styled.div`
  position: relative;
  margin-top: 35px;
  padding: 15px 20px;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  gap: 0 15px;
  width: 100%;

  & .react-datepicker__tab-loop {
    position: absolute;
  }
`;

const CateIn = styled.div`
  display: flex;
  align-items: center;
  gap: 0 20px;
`;

const Cate = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & label {
    font-weight: 400;
    font-size: 16px;
    color: #777777;
  }
`;

const CateInput = styled.input`
  width: 160px;
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  font-weight: 400;
  font-size: 16px;
  color: #777777;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  outline: none;
`;

const SearchBtn = styled.button`
  width: 120px;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: #a4a4a4;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;

  &:hover {
    background-color: #7e7e7e;
  }
`;

const Ic = styled.img.attrs({ alt: 'Util Icon' })``;

const Content = styled.div`
  margin-top: 35px;
  position: relative;
  height: 622px;
  overflow-y: scroll;
`;

const Table = styled.table`
  position: relative;

  & th {
    padding: 15px 0;
    font-weight: 400;
    font-size: 18px;
    color: #777777;
    background: #f8f8f8;
    text-align: center;
    border-bottom: 1px solid #eeeeee;
    vertical-align: middle;
  }

  & td {
    padding: 10px 0;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    text-align: center;
    vertical-align: middle;
    border-bottom: 1px solid #eeeeee;
    border-left: 1px solid #eeeeee;
    height: 47px;
  }

  & thead {
    position: sticky;
    top: 0;
  }

  & tbody > tr {
    cursor: pointer;

    &:hover {
      & td {
        background: #f4f4f4;
      }
    }
  }

  & tr td.none-data {
    height: 572px;
    border: 0;
  }

  & tr td:first-child {
    border-left: none;
  }

  & tr:nth-child(even) {
    background: #fcfcfc;
  }
`;

export default Dispatch;